const course = [
    {
        path: '/courseMain',
        name: 'courseMain',
        meta: { breadcrumb: '课程中心', requiresAuth: true },
        component: () => import('@/views/course/CourseMain.vue'),
        redirect: '/courseList',
        children: [{
          path: '/courseCentre',
          name: 'courseCentre',
          meta: { breadcrumb: '课程列表', requiresAuth: true },
          component: () => import('@/views/course/pages/CourseCentre.vue')
        }, {
          path: '/courseList',
          name: 'courseList',
          meta: { breadcrumb: '课程列表', requiresAuth: true },
          component: () => import('@/views/course/pages/CourseList.vue')
        }, {
          path: '/courseDetail',
          name: 'courseDetail',
          meta: { breadcrumb: '课程详情', requiresAuth: true },
          component: () => import('@/views/course/pages/CourseDetail.vue')
        }, {
          path: '/courseDetail_v1',
          name: 'courseDetail',
          meta: { breadcrumb: '课程详情', requiresAuth: true },
          component: () => import('@/views/course/pages/CourseDetail_v1.vue')
        }]
      }
]

export default course